import axios from "axios";
import { takeLatest, put, call } from "redux-saga/effects";
import { addContactSuccess, addContactFaild } from "../actions/contact";
import { baseUrl } from "../../utils/index";

const parseApiError = (data) => {
  if (!data) return { eng: "Request failed", amh: "ጥያቄ አልተሳካም" };
  if (data.msg?.eng || data.msg?.amh) return data.msg;
  if (typeof data.msg === "string") return { eng: data.msg, amh: data.msg };
  return { eng: "Request failed", amh: "ጥያቄ አልተሳካም" };
};

function addContactApi({ values }) {
  return axios.post(`${baseUrl}/contact/add-new-message`, values);
}

function* addContact({ payload: { values } }) {
  try {
    const contactResponse = yield call(addContactApi, { values });
    const data = contactResponse.data;
    if (data?.error) {
      yield put(addContactFaild(parseApiError(data)));
      return;
    }
    yield put(addContactSuccess(data.msg));
  } catch (error) {
    yield put(
      addContactFaild(parseApiError(error.response?.data || { msg: error.message }))
    );
  }
}

function* addContac() {
  yield takeLatest("ADD_CONTACT_REQUESTED", addContact);
}
export { addContac };
